import logo from "../assets/logo-oui-investimentos.png";

import { ThemeType } from "./defaultTheme";

const themeProps = {
  fonts: {
    primary: "Open Sans, sans-serif",
    pre: "Consolas, Liberation Mono, Menlo, Courier, monospace",
    quote: "Georgia, serif",
  },
  navbar: {
    show: false,
  },
  localeSettings: {
    showInsideLeftColumn: true,
  },
  logo: {
    img: logo,
    height: "78px",
    padding: "10px 0px",
    align: "center",
    show: false,
  },
  colors: {
    textDefault: "#343A40",
    textFaded: "rgba(37, 64, 87, 0.5)",
    textDark: "#254057",
    textGray: "rgba(51, 51, 51, 0.6)",
    textWhite: "#FFFFFF",
    textBlack: "#000000",
    textDarkGray: "#333333",
    bgPrimary: "white",
    bgSecondary: "gray",
    bgGray: "#F1F3F5",
    iconCyan: "#00A9FE",
    selectedBlue: "#09B4FF",
    selectedLightBlue: "#D9F2FF",
    funds: "#604AF0",
    stocks: "#F09C62",
    fixedIncome: "#BE56F0",
    pension: "#32A32A",
    leftover: "rgba(51, 51, 51, 0.6)",
    custom: "#3E85F0",
    addButtonPrimary: "#254057",
    addButtonSecondary: "rgba(37,64,87,0.48)",
    addButtonText: "#FFFFFF",
    removeButtonPrimary: "#254057",
    removeButtonSecondary: "rgba(223, 11, 11, 0.48)",
    removeButtonText: "#FFFFFF",
    cardBorder: "#F2F1F6",
    cardBg: "#FFFFFF",
    cardBgSelected: "#D9F2FF",
    cardCheckboxChecked: "#00A9FE",
    cardCheckboxUnchecked: "rgba(51, 51, 51, 0.25)",
    periodButtonDark: "#333333",
    periodButtonLight: "#FFFFFF",
    periodButtonSelected: "#254057",
    periodButtonHover: "#476885",
    portfolioButtonHover: "#EFF1F3",
    accordionTitleBg: "#254057",
    accordionTitleFg: "white",
    alertRed: "#DF0B0B",
    showAssetsButtonLight: "#FFFFFF",
    showAssetsButtonHover: "#476885",
    showAssetsButtonDark: "#333333",
    showAssetsButtonSelected: "#254057",
    bgQuantumBanner: "#666",
    addAssetBorder: "#00a9fe",
    addAssetTextColor: "#254057",
    addAssetBackground: "#D9F2FF",
    snackbarMessageSuccess: "#27618F",
    snackbarMessageError: "#DF0B0B",
    shareButtonLight: "#FFFFFF",
    shareButtonHover: "#476885",
    shareButtonDark: "#333333",
  },
};

export const ouiTheme: ThemeType = themeProps;
